export type AuthMode = 'admin' | 'client'

export interface AuthState {
  mode: AuthMode
  projectCode: string | null
}

export interface ValidateResponse {
  mode: AuthMode
  project_code: string | null
}

const ADMIN_SESSION_KEY = 'bt_admin_token'

export function setAdminToken(password: string) {
  if (typeof window === 'undefined') return
  sessionStorage.setItem(ADMIN_SESSION_KEY, password)
}

export function clearAdminToken() {
  if (typeof window === 'undefined') return
  sessionStorage.removeItem(ADMIN_SESSION_KEY)
}

export function getAdminToken(): string | null {
  if (typeof window === 'undefined') return null
  return sessionStorage.getItem(ADMIN_SESSION_KEY)
}

export function getAuthFromSearch(search: string): AuthState | null {
  const params = new URLSearchParams(search)
  const projectCode = params.get('project')?.trim() || null
  const isAdmin = params.get('admin') === '1'

  if (isAdmin && getAdminToken()) {
    return { mode: 'admin', projectCode }
  }

  if (projectCode) {
    return { mode: 'client', projectCode }
  }

  return null
}

export function buildAuthSearch(auth: AuthState | null): string {
  if (!auth) return ''

  const params = new URLSearchParams()
  if (auth.mode === 'admin') {
    params.set('admin', '1')
  }
  if (auth.projectCode) {
    params.set('project', auth.projectCode)
  }

  const search = params.toString()
  return search ? `?${search}` : ''
}

export function buildAppHref(path: string, auth: AuthState | null): string {
  const search = buildAuthSearch(auth)
  return search ? `${path}${search}` : path
}
